import React from 'react';
import classnames from 'classnames';

const CSS = require('./Paragraph.less');

interface ParagraphProps {
  children: any;
  className?: string;
  [key: string]: any;
}

function Paragraph({ children, className, ...rest }: ParagraphProps) {
  const classes = classnames(CSS.Paragraph, {
    [className]: !!className,
  });

  return (
    <p className={classes} {...rest}>{children}</p>
  )
}

export default Paragraph;
